(function() {
  'use strict';

  angular
    .module('contentPlayer.contentPlayerHeaderCtrl', ['factories.mobileHelper'])
    .controller('ContentPlayerHeaderCtrl', ContentPlayerHeaderCtrl);

  ContentPlayerHeaderCtrl.$inject = ['$scope', 'PlayerControls', 'Auth', 'Navigation', '$modal', '$route', 'MobileHelper'];

  function ContentPlayerHeaderCtrl($scope, PlayerControls, Auth, Navigation, $modal, $route, MobileHelper) {
    var preview;

    $scope.playerControls = PlayerControls;
    $scope.navigation = Navigation;

    preview = $route && $route.current && $route.current.originalPath && !!~$route.current.originalPath.indexOf('preview');

    $scope.viewState = {
      sendSMEPreviewAvailable: preview,
      logoutAvailable: (!preview || MobileHelper.isNativeIpadApp) && Navigation.playerType !== 'public',
      emailTrainerAvailable: !preview
    };

    $scope.signOut = Auth.logout;

    $scope.goHome = function() {
      Navigation.resetNextCModuleUrl();
      Navigation.exitPlayer();
    };

    $scope.openEmailTrainer = function() {
      $modal.open({ templateUrl: 'contentPlayer/emailTrainer.html', controller: 'EmailTrainerCtrl', scope: $scope });
    };

    $scope.openSme = function() {
      $modal.open({ templateUrl: 'contentPlayer/sendPreview.html', controller: 'SendPreviewCtrl', scope: $scope });
    };
  }
})();
